import React from 'react';
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Button, Col, Modal, Row } from '@folio/stripes/components';
import { updateUser } from '@folio/stripes/core';

/**
 * Show a modal with buttons for each available service-point,
 */
class ServicePointsModal extends React.Component {
  static propTypes = {
    stripes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    intl: PropTypes.object.isRequired,
  };

  setCurrentServicePoint(servicePoint) {
    const { stripes, onClose } = this.props;

    // persist to storage and dispatch, causing root and stripes to re-render
    updateUser(stripes.store, { curServicePoint: servicePoint });

    if (onClose) {
      onClose();
    }
  }

  render() {
    const { stripes, open, onClose } = this.props;
    const servicePoints = stripes?.user?.user?.servicePoints ?? [];
    const curServicePoint = stripes?.user?.user?.curServicePoint ?? {};

    return (
      <Modal
        data-test-servicepoints-modal
        open={open}
        onClose={onClose}
        closeOnBackgroundClick
        dismissible
        label={<FormattedMessage id="ui-servicepoints.selectServicePoint" />}
      >
        <Col xs={12}>
          <Row>
            {sortBy(servicePoints, ['name']).map((sp, index) => (
              <Button
                buttonStyle={
                  curServicePoint.id === sp.id ? 'primary' : 'default'
                }
                key={sp.id}
                id={`service-point-btn-${index}`}
                fullWidth
                onClick={() => this.setCurrentServicePoint(sp)}
              >
                {/* kware start edit - Add service point name translation */}
                {this.props.intl.formatMessage({
                  id: `ui-tenant-settings.servicePoints.name.${sp.name}`,
                  defaultMessage: sp.name,
                })}
                {/* kware end edit */}
              </Button>
            ))}
          </Row>
        </Col>
      </Modal>
    );
  }
}

export default injectIntl(ServicePointsModal);
